var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("progress-bar", {
        attrs: { type: "info", striped: "", label: "" },
        model: {
          value: _vm.percentageCompleted,
          callback: function ($$v) {
            _vm.percentageCompleted = $$v
          },
          expression: "percentageCompleted",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _vm.authenticated
          ? _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("treeselect", {
                  attrs: {
                    value: _vm.contentType,
                    options: _vm.jsonParsedOptions,
                    placeholder: "Please select a metadata type",
                    multiple: false,
                    clearable: true,
                    "disable-branch-nodes": true,
                    "show-count": true,
                    "flatten-search-results": true,
                  },
                  on: { input: _vm.changeContentType },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.authenticated
          ? _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.workgroupOptions,
                    placeholder: "Please select a Workgroup (optional)",
                    multiple: false,
                    clearable: true,
                  },
                  model: {
                    value: _vm.selectedWorkGroup,
                    callback: function ($$v) {
                      _vm.selectedWorkGroup = $$v
                    },
                    expression: "selectedWorkGroup",
                  },
                }),
                _vm._v(" "),
                _vm._m(0),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("treeselect", {
                  attrs: {
                    value: _vm.contentType,
                    options: _vm.jsonParsedOptions,
                    placeholder: "Please select a metadata type",
                    multiple: false,
                    clearable: true,
                    "disable-branch-nodes": true,
                    "show-count": true,
                    "flatten-search-results": true,
                  },
                  on: { input: _vm.changeContentType },
                }),
              ],
              1
            ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-title" }, [
        _vm._v("Download Template"),
      ]),
      _vm._v(" "),
      _vm.authenticated && _vm.contentType
        ? _c("div", { staticClass: "row checkboxGroup" }, [
            _c("h4", { staticClass: "col-md-12" }, [_vm._v("Options")]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("h4", [
                _vm._v("Custom Fields "),
                _c(
                  "a",
                  { attrs: { href: _vm.getHelpLink, target: "_blank" } },
                  [_c("i", { staticClass: "fa fa-question-circle" })]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.includeCommonCustomFields,
                      expression: "includeCommonCustomFields",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.includeCommonCustomFields)
                      ? _vm._i(_vm.includeCommonCustomFields, null) > -1
                      : _vm.includeCommonCustomFields,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.includeCommonCustomFields,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.includeCommonCustomFields = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.includeCommonCustomFields = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.includeCommonCustomFields = $$c
                      }
                    },
                  },
                }),
                _vm._v(" Include general custom fields\n            "),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.includeSpecificCustomFields,
                      expression: "includeSpecificCustomFields",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.includeSpecificCustomFields)
                      ? _vm._i(_vm.includeSpecificCustomFields, null) > -1
                      : _vm.includeSpecificCustomFields,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.includeSpecificCustomFields,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.includeSpecificCustomFields = $$a.concat([
                              $$v,
                            ]))
                        } else {
                          $$i > -1 &&
                            (_vm.includeSpecificCustomFields = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.includeSpecificCustomFields = $$c
                      }
                    },
                  },
                }),
                _vm._v(" Include\n                "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.contentType
                        ? _vm.optionsMapping[_vm.contentType]
                        : "model"
                    )
                  ),
                ]),
                _vm._v(" specific custom fields\n            "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("h4", [_vm._v("Alternative Names and Identifiers")]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.includeAlternativeNames,
                      expression: "includeAlternativeNames",
                    },
                  ],
                  attrs: {
                    type: "checkbox",
                    disabled: !_vm.isTreeselectSelected,
                  },
                  domProps: {
                    checked: Array.isArray(_vm.includeAlternativeNames)
                      ? _vm._i(_vm.includeAlternativeNames, null) > -1
                      : _vm.includeAlternativeNames,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.includeAlternativeNames,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.includeAlternativeNames = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.includeAlternativeNames = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.includeAlternativeNames = $$c
                      }
                    },
                  },
                }),
                _vm._v(" Include alternative names\n            "),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.includeIdentifiers,
                      expression: "includeIdentifiers",
                    },
                  ],
                  attrs: {
                    type: "checkbox",
                    disabled: !_vm.isTreeselectSelected,
                  },
                  domProps: {
                    checked: Array.isArray(_vm.includeIdentifiers)
                      ? _vm._i(_vm.includeIdentifiers, null) > -1
                      : _vm.includeIdentifiers,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.includeIdentifiers,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.includeIdentifiers = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.includeIdentifiers = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.includeIdentifiers = $$c
                      }
                    },
                  },
                }),
                _vm._v(" Include identifiers"),
                _c(
                  "a",
                  { attrs: { href: _vm.namespaceHelpLink, target: "_blank" } },
                  [
                    this.selectedWorkGroup
                      ? _c("i", { staticClass: "fa fa-question-circle" })
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "text-center download-btn" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-outline-info btn-block",
            class: { disabled: !_vm.contentType },
            attrs: {
              href: _vm.getUrl(_vm.computedDownloadUrl),
              download: _vm.contentType,
            },
          },
          [
            _vm.contentType
              ? _c("i", { staticClass: "fad fa-file-download" })
              : _c("span", [_vm._v("​")]),
            _vm._v(
              "\n                    " +
                _vm._s(_vm.getDownloadButtonText) +
                "\n                "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-title" }, [_vm._v("Upload Metadata")]),
      _vm._v(" "),
      _c("aristotle-file-pond", {
        ref: "aristotlepond",
        attrs: {
          url: _vm.url,
          "status-url": _vm.statusUrl,
          "label-idle": _vm.getLabelIdle(),
          "current-tags": _vm.currentTags,
          "selected-work-group": _vm.selectedWorkGroup,
          "content-type": _vm.contentType,
          disabled: !_vm.contentType,
        },
        on: {
          changeProgress: _vm.changeProgress,
          changeLoadingMessage: _vm.changeLoadingMessage,
          changeNumberOfSteps: _vm.changeNumberOfSteps,
          changeFileIsLoaded: _vm.changeFileIsLoaded,
          changeErrors: _vm.changeErrors,
          changeListOfMetadataRepresentations:
            _vm.changeListOfMetadataRepresentations,
          changeIsLoading: _vm.changeIsLoading,
          changeExcelToCsvMessage: _vm.changeExcelToCsvMessage,
          changeShowLoginMessage: _vm.changeShowLoginMessage,
          changeTags: _vm.changeTags,
          changeSelectedWorkgroup: _vm.changeSelectedWorkgroup,
        },
      }),
      _vm._v(" "),
      _vm.contentType
        ? _c(
            "div",
            [
              _c("file-uploader-error-display", {
                attrs: { errors: _vm.errors },
              }),
              _vm._v(" "),
              _vm.showLoginMessage
                ? _c("div", { staticClass: "alert alert-info" }, [
                    _vm._v(
                      "\n            Your file has been processed and the following metadata items were found in the file.\n            You will need to log in to save these metadata items.\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.excelToCsvMessage
                ? _c("div", { staticClass: "alert alert-info" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.excelToCsvMessage) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _vm.fileIsLoaded
                        ? _c("file-uploader-options", {
                            attrs: {
                              "user-workgroups": _vm.userWorkgroups,
                              "user-tags": _vm.userTags,
                              type: "abc",
                            },
                            on: { changeTags: _vm.changeTags },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("table-of-contents", {
                        attrs: {
                          "list-of-metadata-representations":
                            _vm.listOfMetadataRepresentations,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-8" },
                    [
                      _vm.fileIsLoaded
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-success pull-right",
                              attrs: { disabled: _vm.isDisabled },
                              on: { click: _vm.submitFile },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.buttonMessage) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.fileIsLoaded
                        ? _c("p", [
                            _vm._v(
                              "\n                    Your file has been processed and the following metadata items were found in the\n                    file."
                            ),
                            _vm.isDisabled
                              ? _c("span", [
                                  _vm._v("When you include the "),
                                  _vm._m(1),
                                  _vm._v(" or "),
                                  _vm._m(2),
                                  _vm._v(
                                    ", you must select a Workgroup first, then"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(
                              '\n                    click "' +
                                _vm._s(_vm.buttonMessage) +
                                '" to save these items into the registry.\n                '
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.percentageCompleted === 100
                        ? _c("p", [
                            _vm._v(
                              "\n                    The objects provided in the file have been successfully created! Click on the links below to see\n                    the items in a new tab.\n                "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("metadata-representation", {
                        attrs: {
                          "list-of-metadata-representations":
                            _vm.listOfMetadataRepresentations,
                          "namespace-id-name-mapping-api-url":
                            _vm.namespaceIdNameMappingApiUrl,
                          "selected-work-group": _vm.selectedWorkGroup,
                          workgroups: _vm.workgroupOptions,
                          "file-is-loaded": _vm.fileIsLoaded,
                          "system-name-to-name-mapping":
                            _vm.systemNameToNameMapping,
                        },
                      }),
                      _vm._v(" "),
                      _vm.fileIsLoaded
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-success pull-right",
                              attrs: { disabled: _vm.isDisabled },
                              on: { click: _vm.submitFile },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.buttonMessage) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isLoading
                    ? _c("loading", {
                        attrs: { "loading-message": _vm.loadingMessage },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "help-block" }, [
      _vm._v("\n                        If you need to include the "),
      _c("strong", [_c("em", [_vm._v("Alternative Names")])]),
      _vm._v(" or "),
      _c("strong", [_c("em", [_vm._v("Identifiers")])]),
      _vm._v(", you must select a Workgroup to "),
      _c("em", [_vm._v("download")]),
      _vm._v(
        " the template.\n                        Additionally, make sure to select the correct Workgroup before proceeding to "
      ),
      _c("em", [_vm._v("upload")]),
      _vm._v(" your file.\n                "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [_c("em", [_vm._v("Alternative Names")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [_c("em", [_vm._v("Identifiers")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }